<a (click)="onClick()">
  <div *ngIf="!isListMode" class="art-box">
    <div>
      <div>
        <h2 *ngIf="title" class="{{changeFontSizeClass}}" [innerHTML]="title | translate"></h2>
        <p *ngIf="description" class="art-box-sub-1" [innerHTML]="description | translate"></p>
        <p>
        </p>
        <p *ngIf="additionalDescription" class="art-box-sub-2" [innerHTML]="additionalDescription | translate"></p>
        <p>
        </p>
      </div>
    </div>
  </div>
  <div *ngIf="isListMode" class="ng-box">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 align-self-center text-center text-sm-left">
            <div>
              <h3 class="text-center">{{ title | translate }}</h3>
              <p>
                <span *ngIf="description">{{ description }}</span>
                <span *ngIf="additionalDescription">{{ additionalDescription | translate }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
  </div>
</a>

